import firebase from 'firebase'
import 'firebase/storage'

export const app = firebase.initializeApp({
   storageBucket: "task-322014.appspot.com",
  });